export default __webpack_public_path__ + "static/media/sana1.393947c0.mp4";